// extracted by mini-css-extract-plugin
export var actionButton = "_pc-0";
export var actionMenuContainer = "_pc-i";
export var bubble = "_pc-2";
export var bubbleActionMenu = "_pc-j";
export var bubbleContext = "_pc-6";
export var bubbleItems = "_pc-7";
export var customer = "_pc-3";
export var divider = "_pc-8";
export var fileList = "_pc-9";
export var hiddenComment = "_pc-o";
export var infoAbove = "_pc-a";
export var internal = "_pc-4";
export var lightActionButton = "_pc-1";
export var link = "_pc-b";
export var merchant = "_pc-5";
export var message = "_pc-c";
export var profilePicture = "_pc-e";
export var quillToolbarContainer = "_pc-f";
export var senderDate = "_pc-g";
export var senderDateCustomer = "_pc-h";
export var senderName = "_pc-d";
export var time = "_pc-k";
export var uploadedImage = "_pc-l";
export var username = "_pc-m";
export var xsmall = "_pc-n";